import { clerkFetch } from "./clerkFetch";

// Spec 5 PR 4 Task 32 — token + health functions DEPRECATED.
// Replaced by useQuery/useAction over api.mcp.tokens.* and
// api.mcp.accessLog.* via convex/react. The stubs below throw so any
// straggler caller fails loudly. Full deletion of this file scheduled
// for PR 8 (frontend cutover).
//
// The installAgent / uninstallAgent functions stay — they're separate
// concerns kept on the REST surface in PR 4 and migrated later.

// === Types kept for compat with ConnectAgentsTab during cutover ===

export interface McpTokenRecord {
  id: string;
  label: string;
  createdBy: string;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface MintMcpTokenResponse {
  rawToken: string;
  record: McpTokenRecord;
}

export interface McpHealthResponse {
  rollingCallsLast24h: number;
  perTokenUsage: Array<{
    tokenId: string;
    label: string;
    callCount: number;
    lastUsedAt: number | null;
  }>;
  lastErrors: Array<{
    tokenId: string;
    timestamp: number;
    errorCode: number;
    errorMessage: string;
  }>;
}

export interface InstallResponse {
  ok: boolean;
  output: string;
}

// === DEPRECATED token + health client functions ===

export async function listMcpTokens(): Promise<never> {
  throw new Error("listMcpTokens deprecated — use useQuery(api.mcp.tokens.queries.list)");
}

export async function mintMcpToken(_label: string): Promise<never> {
  throw new Error("mintMcpToken deprecated — use useAction(api.mcp.tokens.actions.mintToken)");
}

export async function revokeMcpToken(_id: string, _reason: string): Promise<never> {
  throw new Error("revokeMcpToken deprecated — use useAction(api.mcp.tokens.actions.revokeToken)");
}

export async function getMcpHealth(): Promise<never> {
  throw new Error("getMcpHealth deprecated — use useQuery(api.mcp.accessLog.queries.recent)");
}

// === Live install/uninstall client functions (kept for PR 4) ===

export async function installAgent(agent: string, token?: string): Promise<InstallResponse> {
  const res = await clerkFetch(`/api/admin/mcp/install/${agent}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(token ? { token } : {}),
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`installAgent(${agent}) failed: ${res.status} ${txt}`);
  }
  return res.json();
}

export async function uninstallAgent(agent: string, reason: string): Promise<InstallResponse> {
  const res = await clerkFetch(`/api/admin/mcp/uninstall/${agent}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reason }),
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`uninstallAgent(${agent}) failed: ${res.status} ${txt}`);
  }
  return res.json();
}

// Canonical list of agents supported by the install routes. MUST match
// MCP_INSTALL_AGENT_ALLOWLIST in src/server.js (Task 35) — drift here would
// surface in the UI as a 400 from the install route.
export const SUPPORTED_AGENTS: ReadonlyArray<{ value: string; label: string }> = Object.freeze([
  { value: "claude-code", label: "Claude Code" },
  { value: "codex-cli", label: "Codex CLI" },
  { value: "cursor", label: "Cursor" },
  { value: "gemini-cli", label: "Gemini CLI" },
  { value: "claude-desktop", label: "Claude Desktop" },
]);
